import { useMutation } from 'react-query';
import { AuthContext } from '../../Context/AuthContext'; 
import { useContext } from 'react';

const useRegisterDriver = () => {
  const { token } = useContext(AuthContext);

  const registerDriver = async (formData) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/users/register/driver`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Driver registration failed');
    }

    return response.json();
  };

  return useMutation(registerDriver);
};

export default useRegisterDriver;
